const minilog = require('minilog');
minilog.enable();

module.exports = minilog('scratch-audioengine');



//////////////////
// WEBPACK FOOTER
// ./node_modules/scratch-audio/src/log.js
// module id = FLZd
// module chunks = 0